// extracted by mini-css-extract-plugin
export default {"fixedHeader":"FixedHeader_fixedHeader__YQ+Rn","shadow":"FixedHeader_shadow__b+sRk","blurred":"FixedHeader_blurred__Fwfpy"};